module.exports = __webpack_public_path__ + "img/mega_neon.16c36a06.svg";